import React from "react";
import PageHeader, { PageCTA } from "../components/PageHeader";
import Calculator from "../components/Calculator";
import LeadMagnet from "../components/LeadMagnet";

export default function CalculatorPage() {
  return (
    <div data-testid="page-kalkulator">
      <PageHeader
        eyebrow="Kalkulator"
        title={
          <>
            Czy Twoja firma{" "}
            <span className="gold-gradient-text italic">zarabia?</span>
          </>
        }
        subtitle="Wprowadź podstawowe dane finansowe z ostatniego miesiąca. W mniej niż 60 sekund dowiesz się, jak wygląda Twoja rentowność i co można poprawić."
      />
      <Calculator />
      <LeadMagnet />
      <PageCTA
        title="Potrzebujesz głębszej analizy?"
        text="Na bezpłatnej rozmowie omówimy Twoje liczby w detalu i wskażę konkretny plan działania."
        buttonLabel="Umów rozmowę"
        to="/kontakt"
      />
    </div>
  );
}
